import { attr } from '@ember-data/model';
import Super from './document-request';

export default class DocumentRequestPostSessionSummary extends Super {
  documentIcon = 'file-text';
  mixpanelType = 'Post Session Summary';

  @attr() documentBody;
  @attr() documentDate;

  get hasDocumentPdf() {
    return this.isComplete;
  }
}
